/* eslint-disable import/order */
import { takeLatest, put, call, take, fork, takeEvery } from 'redux-saga/effects';

import {
  USER_PROFILE_VALIDATE_LOGIN,
  USER_PROFILE_LOGIN,
  USER_PROFILE_LOGOUT,
  USER_PROFILE_LOGIN_SUCCESS,
  USER_PROFILE_LOGIN_REQUEST,
  USER_PROFILE_LOGIN_FAIL,
  USER_PROFILE_LOGOUT_SUCCESS,
  USER_PROFILE_LOGOUT_REQUEST,
  USER_PROFILE_LOGOUT_FAIL,
  USER_PROFILE_GETPROFILE_REQUEST,
  USER_PROFILE_GETPROFILE_SUCCESS,
  USER_PROFILE_GETPROFILE_FAIL,
  USER_PROFILE_GETPROFILE,
  USER_PROFILE_SIGN_UP_WITH_EMAIL,
  USER_PROFILE_SIGN_UP_WITH_EMAIL_REQUEST,
  USER_PROFILE_SIGN_UP_WITH_EMAIL_SUCCESS,
  USER_PROFILE_SIGN_UP_WITH_EMAIL_FAIL,
  USER_PROFILE_ADD_PERSONAL_INFORMATION,
  USER_PROFILE_ADD_PERSONAL_INFORMATION_FAIL,
  USER_PROFILE_ADD_PERSONAL_INFORMATION_REQUEST,
  USER_PROFILE_ADD_PERSONAL_INFORMATION_SUCCESS,
  setProfile,
  setProfileLoading,
  // loginSuccess,
  // loginFail,
} from './actions';

import { callApi } from '../callApi/actions';
import { callFirebase } from '../firebaseCall/actions';
import getConfig from '../../Util/Config';

import { FIREBASE_TYPE } from '../../Firebase';

import fetch2, { METHOD } from '../../Util/fetch';

const USER_API = getConfig().userApi;

function fetchUserInfo() {
  // return Firebase.onAuthStateChanged();
  return callFirebase(FIREBASE_TYPE.GET_USER, {}, [
    USER_PROFILE_GETPROFILE_REQUEST,
    USER_PROFILE_GETPROFILE_SUCCESS,
    USER_PROFILE_GETPROFILE_FAIL,
  ]);
}

function login(type, username, password) {
  if (type === 'EMAIL') {
    return callFirebase(
      FIREBASE_TYPE.SIGNIN_EMAIL,
      {
        email: username,
        password,
      },
      [USER_PROFILE_LOGIN_REQUEST, USER_PROFILE_LOGIN_SUCCESS, USER_PROFILE_LOGIN_FAIL],
    );
  } else if (type === 'FACEBOOK') {
    return callFirebase(FIREBASE_TYPE.SIGNIN_FACEBOOK, {}, [
      USER_PROFILE_LOGIN_REQUEST,
      USER_PROFILE_LOGIN_SUCCESS,
      USER_PROFILE_LOGIN_FAIL,
    ]);
  } else if (type === 'ANONYMOUS') {
    return callFirebase(FIREBASE_TYPE.SIGNIN_ANONYMOUS, {}, [
      USER_PROFILE_LOGIN_REQUEST,
      USER_PROFILE_LOGIN_SUCCESS,
      USER_PROFILE_LOGIN_FAIL,
    ]);
  }
  // return callApi(
  //   'login',
  //   `${USER_API}/login`,
  //   {
  //     path: 'http://localhost:3008/api/users/login',
  //     method: METHOD.POST,
  //     body: {
  //       email: username,
  //       password,
  //     },
  //   },
  //   [USER_PROFILE_LOGIN_REQUEST, USER_PROFILE_LOGIN_SUCCESS, USER_PROFILE_LOGIN_FAIL]
  // );
}

function signUp(username, password) {
  return callFirebase(
    FIREBASE_TYPE.SIGN_UP_EMAIL,
    {
      email: username,
      password,
    },
    [
      USER_PROFILE_SIGN_UP_WITH_EMAIL_REQUEST,
      USER_PROFILE_SIGN_UP_WITH_EMAIL_SUCCESS,
      USER_PROFILE_SIGN_UP_WITH_EMAIL_FAIL,
    ],
  );
}

function logout() {
  return callFirebase(FIREBASE_TYPE.SIGNOUT, {}, [
    USER_PROFILE_LOGOUT_REQUEST,
    USER_PROFILE_LOGOUT_SUCCESS,
    USER_PROFILE_LOGOUT_FAIL,
  ]);
  // return callApi(
  //   'logout',
  //   `${USER_API}/logout`,
  //   {
  //     method: METHOD.POST,
  //   },
  //   [USER_PROFILE_LOGOUT_REQUEST, USER_PROFILE_LOGOUT_SUCCESS, USER_PROFILE_LOGOUT_FAIL]
  // );
}

function AddPersonalInformation() {
  return callFirebase(FIREBASE_TYPE.ADD_PERSONAL_INFORMATION, {}, [
    USER_PROFILE_ADD_PERSONAL_INFORMATION_REQUEST,
    USER_PROFILE_ADD_PERSONAL_INFORMATION_SUCCESS,
    USER_PROFILE_ADD_PERSONAL_INFORMATION_FAIL,
  ]);
}

function* doLogin({ payload }) {
  yield put(login(payload.type, payload.username, payload.password));
  // try {
  //   const response = yield call(
  //     [Firebase, Firebase.signinWithEmail],
  //     payload.username,
  //     payload.password,
  //     () => {}
  //   );
  //   console.log('doLogin resolve:', response);
  //   yield put({ type: USER_PROFILE_LOGIN_SUCCESS, payload: { key: 'login', result: response } });
  // } catch (error) {
  //   console.log('doLogin reject:', error);
  //   yield put({ type: USER_PROFILE_LOGIN_FAIL, payload: { key: 'login', error } });
  // }
}

function* doSignup({ payload }) {
  yield put(signUp(payload.username, payload.password));
}

function* doAddPersonalInformation() {
  yield put(AddPersonalInformation());
}

function* doLogout() {
  yield put(logout());
}

export function* onLoginPass() {
  yield takeEvery(USER_PROFILE_LOGIN_SUCCESS, function*() {
    yield put(fetchUserInfo());
  });
}

export function* onRegisterPass() {
  yield takeEvery(USER_PROFILE_SIGN_UP_WITH_EMAIL_SUCCESS, function*() {
    yield put(fetchUserInfo());
  });
}

export function* clearUserInfo() {
  yield takeEvery(USER_PROFILE_LOGOUT_SUCCESS, function*() {
    yield put(setProfile(null));
    yield put(setProfileLoading(false));
  });
}

export function* requestUserInfo() {
  yield take(USER_PROFILE_GETPROFILE);
  yield put(fetchUserInfo());
}

export function* performLogin() {
  yield takeLatest(USER_PROFILE_LOGIN, doLogin);
}

export function* performAddPersonalInformation() {
  yield takeLatest(USER_PROFILE_ADD_PERSONAL_INFORMATION, doAddPersonalInformation);
}

export function* performSignUp() {
  yield takeLatest(USER_PROFILE_SIGN_UP_WITH_EMAIL, doSignup);
}

export function* performLogout() {
  yield takeLatest(USER_PROFILE_LOGOUT, doLogout);
}

export default [
  onLoginPass(),
  onRegisterPass(),
  performLogin(),
  performSignUp(),
  performAddPersonalInformation(),
  performLogout(),
  requestUserInfo(),
  clearUserInfo(),
];
